import React from 'react'
import CollectionContext from '../contexts/CollectionContext'

export default function useCollection () {
  return React.useContext(CollectionContext)
}
